import Zoomist from 'zoomist'

import Lightbox from 'Feature/Lightbox/Code/Scripts/Lightbox/lightbox';
import getRandomNumberInRange from "General/global-js/randomNumber";
import('Foundation/Common/code/Scripts/Events/ResizeEndEvent');

import(/* webpackChunkName: "imageZoom" */ '../Styles/imageZoom.scss');

window.am = window.am || {};

window.am.imageZoom = new function () {
    let maxWidthMobile = 768;
    let maxWidthTablet = 1024;
    let zoomistOptions = {
        zoomRatio: 0.5,
        zoomRatioMax: 4.0,
    };

    this.init = () => {
        let imageElements = document.querySelectorAll('img[data-image-zoom]:not([data-image-zoom=""]), [data-image-zoom]:not([data-image-zoom=""]) img');

        imageElements.forEach((image) => {
            let options = parseOptions(image);
            if (!options) {
                return;
            }

            let lightboxId = prepareLightbox(image, options);
            if (!lightboxId) {
                return;
            }

            let zoomist;
            let lightboxContainer = document.querySelector(`.lightbox-overlay-container[data-id="${lightboxId}"]`);
            let imageInContainer = lightboxContainer.querySelector('.lightbox-content [data-zoomist-src]');
            
            let initZoomist = () => {
                if (zoomist) {
                    zoomist.destroy();
                }
            
                zoomist = new Zoomist(imageInContainer, {
                    // zoom Ratio
                    zoomRatio: zoomistOptions.zoomRatio,
                    // max zoom ratio
                    maxRatio: zoomistOptions.zoomRatioMax,
                    // height of the zoomist view
                    height: calcZoomistHeight(),
                    // if you need silder
                    slider: false,
                    // if you need zoomer
                    zoomer: false,
                    // if image can be drag out of bounds or not
                    bounds: false,
                });
            };

            let destroyZoomist = () => {
                if (zoomist) {
                    zoomist.destroy();
                }
                zoomist = null;
            };

            let calcZoomistHeight = () => {
                let zoomistHeight;
                let lightboxOverlayMarginMobile = 32;
                let lightboxOverlayMarginDesktop = 64;
                let isMobile = window.innerWidth < maxWidthMobile;
                let isDesktop = window.innerWidth > maxWidthTablet;
                let baseHeight = isMobile ? 1080 : 1920;
                let lightboxOverlayHeight = 0;
                lightboxOverlayHeight += lightboxContainer.querySelector('.overlay-header').offsetHeight;
                lightboxOverlayHeight += lightboxContainer.querySelector('.action-area').offsetHeight;

                if (window.innerHeight >= baseHeight) {
                    zoomistHeight = baseHeight - lightboxOverlayHeight;
                } else {
                    zoomistHeight = window.innerHeight - lightboxOverlayHeight;
                }

                zoomistHeight -= isDesktop ? lightboxOverlayMarginDesktop : lightboxOverlayMarginMobile;

                return zoomistHeight;
            };

            // set events
            window.addEventListener('resizeEnd', initZoomist);
            window.addEventListener("orientationchange", initZoomist);
            lightboxContainer.addEventListener('show', initZoomist);
            lightboxContainer.addEventListener('hide', destroyZoomist);
            
            let zoomOutButton = lightboxContainer.querySelector('.icon.icons-minus');
            let zoomInButton = lightboxContainer.querySelector('.icon.icons-hinzufuegen');

            zoomOutButton.addEventListener('click', () => {
                zoomist.zoom(-zoomistOptions.zoomRatio);
            });
            zoomOutButton.addEventListener('keydown', (e) => {
                switch (e.key) {
                    case 'Enter':
                    case 'Space':
                    case ' ':
                        e.preventDefault();
                        zoomist.zoom(-zoomistOptions.zoomRatio);
                        break;
                }
            });
            
            zoomInButton.addEventListener('click', () => {
                zoomist.zoom(zoomistOptions.zoomRatio);
            });
            zoomInButton.addEventListener('keydown', (e) => {
                switch (e.key) {
                    case 'Enter':
                    case 'Space':
                    case ' ':
                        e.preventDefault();
                        zoomist.zoom(zoomistOptions.zoomRatio);
                        break;
                    case 'Tab':
                        e.preventDefault();
                        lightboxContainer.querySelector('.lightbox-close-button').focus();
                        break;
                }
            });
        });

        Lightbox.init();
    };

    let parseOptions = (image) => {
        try {
            if (image.dataset.imageZoom) {
                return JSON.parse(image.dataset.imageZoom);    
            } else {
                let optionsElement = image.closest('[data-image-zoom]:not([data-image-zoom=""]');

                return JSON.parse(optionsElement.dataset.imageZoom);
            }
        } catch (error) {
            console.error('imageZoom: initialization error: exception on options parse', error, image, optionsElement);
        }

        return null;
    };

    let prepareLightbox = (image, options) => {

        // add icon to image
        let imageIconContainer = document.createElement('div');
        imageIconContainer.classList.add('zoom-container');
        image.parentNode.insertBefore(imageIconContainer, image.nextSibling)

        let imageIcon = document.createElement('span');
        imageIcon.classList.add('icon');
        imageIcon.classList.add('icons-suchen');
        imageIcon.classList.add('image-zoom-click-icon');
        imageIconContainer.appendChild(imageIcon);

        // no lightbox for experience editor
        if (image.closest('[sc-part-of="placeholder rendering"]')) {
            return null;
        }

        // create random id for a temp lightbox-overlay-container
        let lightboxId = getRandomNumberInRange(0, 10000);

        // prepare source image
        image.setAttribute('target', '_lightbox');
        image.setAttribute('data-lightbox-id', lightboxId);
        image.setAttribute('tabindex', '0');
        image.classList.add('focus-effect');

        imageIcon.addEventListener('click', () => image.click());

        // build actual lightbox html
        let lightboxContainer = document.createElement('div');
        if (document.querySelector('body.lottery-page')) {
            lightboxContainer.innerHTML = `<div class="lightbox-overlay-container image-zoom" data-id="${lightboxId}">
            <div class="lightbox-overlay lightbox-overlay--lottery">
                <div class="overlay-header clearfix">
                    <div class="lightbox-image-title">${options.Caption}</div>
                    <a href="javascript:void(0);" class="lightbox-close-button icon icons-schliessen float-right focus-effect" role="button" aria-label="${options.CloseButtonAriaLabel}"></a>
                </div>
                    <div class="lightbox-content image-zoom">
                        <div data-zoomist-src="${options.ImageUrl}"></div>
                    </div>
                <!-- Later for buttons but now only to provide padding space -->
                <div class="action-area">
                    <div class="lightbox-mobile-zoom-hint lightbox-viewport lightbox-mobile">${options.MobileZoomHint}</div>
                    ${options.Caption.length && options.DownloadUrl.length ? `<div class="action-area-spacer"></div>` : ''}
                    <div class="action-area-parts">
                        <div class="lightbox-image-caption lightbox-image-caption--mobile">Du kannst das Motiv über das Icon rechts herunterladen.</div>
                        <div class="lightbox-image-caption lightbox-image-caption--desktop">Du kannst das Motiv über die Icons rechts vergrößern, verkleinern und herunterladen.</div>
                        <div class="lightbox-image-buttons">
                            ${options.DownloadUrl.length ? `<a href="${options.DownloadUrl}" target="_blank"class="lightbox-button lightbox-image-buttons-download focus-effect" role="button" aria-label="${options.DownloadButtonAriaLabel}"><span class="icon icons-download"></span></a>` : ''}
                            <a href="javascript:void(0);" class="lightbox-button icon icons-minus focus-effect lightbox-viewport lightbox-tablet-desktop" role="button" aria-label="${options.ZoomOutButtonAriaLabel}"></a>
                            <a href="javascript:void(0);" class="lightbox-button icon icons-hinzufuegen focus-effect lightbox-viewport lightbox-tablet-desktop" role="button" aria-label="${options.ZoomInButtonAriaLabel}"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
        }
        else {
            lightboxContainer.innerHTML = `<div class="lightbox-overlay-container image-zoom" data-id="${lightboxId}">
            <div class="lightbox-overlay">
                <div class="overlay-header clearfix">
                    <a href="javascript:void(0);" class="lightbox-close-button icon icons-schliessen float-right focus-effect" role="button" aria-label="${options.CloseButtonAriaLabel}"></a>
                </div>
                    <div class="lightbox-content image-zoom">
                        <div data-zoomist-src="${options.ImageUrl}"></div>
                    </div>
                <!-- Later for buttons but now only to provide padding space -->
                <div class="action-area">
                    <div class="lightbox-mobile-zoom-hint lightbox-viewport lightbox-mobile">${options.MobileZoomHint}</div>
                    ${options.Caption.length && options.DownloadUrl.length ? `<div class="action-area-spacer"></div>` : ''}
                    <div class="action-area-parts">
                        <div class="lightbox-image-caption ${options.Caption.length && options.DownloadUrl.length ? '' : 'lightbox-image-caption--hide'}">${options.Caption}</div>
                        <div class="lightbox-image-buttons">
                            ${options.DownloadUrl.length ? `<a href="${options.DownloadUrl}" target="_blank"class="lightbox-button lightbox-image-buttons-download focus-effect" role="button" aria-label="${options.DownloadButtonAriaLabel}"><span class="icon icons-download"></span></a>` : ''}
                            <a href="javascript:void(0);" class="lightbox-button icon icons-minus focus-effect lightbox-viewport lightbox-tablet-desktop" role="button" aria-label="${options.ZoomOutButtonAriaLabel}"></a>
                            <a href="javascript:void(0);" class="lightbox-button icon icons-hinzufuegen focus-effect lightbox-viewport lightbox-tablet-desktop" role="button" aria-label="${options.ZoomInButtonAriaLabel}"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
        }
        

        document.querySelector('main')
                .appendChild(lightboxContainer);

        return lightboxId;
    };
};

window.addEventListener('load', window.am.imageZoom.init);